import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SUPER_ADMIN_DASHBOARD_TABS } from "../../../utility/constants/common-constants";
import { TAB_LABEL_MANAGE_USERS } from "../../../utility/constants/locale";

// Initial state
interface AdminTabsState {
  availableTabs: { value: string; label: string }[];
  activeTab: string;
}

const initialState: AdminTabsState = {
  availableTabs: SUPER_ADMIN_DASHBOARD_TABS,
  activeTab: TAB_LABEL_MANAGE_USERS, // Default to the first tab
};

// Slice
const adminTabsSlice = createSlice({
  name: "adminTabs",
  initialState,
  reducers: {
    setActiveTab(state, action: PayloadAction<string>) {
      state.activeTab = action.payload;
    },
  },
});

// Actions and reducer
export const adminTabsActions = adminTabsSlice.actions;
export default adminTabsSlice.reducer;
